var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconSearchAccaBlue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M44.3334 9.3335H11.6667C10.378 9.3335 9.33337 10.3782 9.33337 11.6668V47.8335C9.33337 49.1222 10.378 50.1668 11.6667 50.1668H44.3334C45.622 50.1668 46.6667 49.1222 46.6667 47.8335V11.6668C46.6667 10.3782 45.622 9.3335 44.3334 9.3335Z",
    fill: "#3987F8"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M35 5.8335H21C20.3557 5.8335 19.8334 6.35583 19.8334 7.00016V11.6668C19.8334 12.3112 20.3557 12.8335 21 12.8335H35C35.6444 12.8335 36.1667 12.3112 36.1667 11.6668V7.00016C36.1667 6.35583 35.6444 5.8335 35 5.8335Z",
    fill: "#2C6CCC"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M22.6042 34.8776C25.5842 34.8776 28 32.4618 28 29.4818C28 26.5017 25.5842 24.0859 22.6042 24.0859C19.6242 24.0859 17.2084 26.5017 17.2084 29.4818C17.2084 32.4618 19.6242 34.8776 22.6042 34.8776Z",
    fill: "#D1E6FF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M33.0809 30.3335H24.6226C23.9783 30.3335 23.4559 30.8558 23.4559 31.5002V39.9585C23.4559 40.6028 23.9783 41.1252 24.6226 41.1252H33.0809C33.7253 41.1252 34.2476 40.6028 34.2476 39.9585V31.5002C34.2476 30.8558 33.7253 30.3335 33.0809 30.3335Z",
    fill: "#94C6F7"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M38.5351 25.3283L30.0767 19.6408C29.6888 19.3812 29.1667 19.6583 29.1667 20.1249V31.497C29.1667 31.9637 29.6888 32.2408 30.0767 31.9812L38.5351 26.2937C38.8792 26.0633 38.8792 25.5558 38.5351 25.3254V25.3283Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M44.0417 54.8333C50.0017 54.8333 54.8333 50.0017 54.8333 44.0417C54.8333 38.0816 50.0017 33.25 44.0417 33.25C38.0816 33.25 33.25 38.0816 33.25 44.0417C33.25 50.0017 38.0816 54.8333 44.0417 54.8333Z",
    fill: "#FFC82A"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M49.3441 47.489L47.492 45.6369C47.8945 44.9282 48.125 44.1115 48.125 43.2394C48.125 40.5444 45.9345 38.354 43.2395 38.354C40.5445 38.354 38.3541 40.5444 38.3541 43.2394C38.3541 45.9344 40.5445 48.1248 43.2395 48.1248C44.1116 48.1248 44.9283 47.8944 45.637 47.4919L47.4891 49.344C47.7458 49.6007 48.0812 49.729 48.4166 49.729C48.752 49.729 49.0875 49.6007 49.3441 49.344C49.8575 48.8307 49.8575 47.9994 49.3441 47.489ZM40.9791 43.2394C40.9791 41.994 41.9941 40.979 43.2395 40.979C44.485 40.979 45.5 41.994 45.5 43.2394C45.5 44.4848 44.485 45.4998 43.2395 45.4998C41.9941 45.4998 40.9791 44.4848 40.9791 43.2394Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSearchAccaBlue);
export default __webpack_public_path__ + "static/media/icon_search_acca_blue.fd5358e3.svg";
export { ForwardRef as ReactComponent };